export const siteName = 'Microsoft Supply Chain Admin Portal';
export const siteTitle = 'OneIAM';
export const supportEmail = 'partnerportalengg@microsoft.com';
export const unknownDomainMessage = `Please reach out to IAM Support Team via ${supportEmail} to create this domain.`;
export const unknownOrgOnboardingError = `Unknown error. Please reach out to IAM Support Team via ${supportEmail} to create this organization.`;